<template>
    <div>
        <router-link :to="{name: 'category-create' }" class="button is-primary is-pulled-right">
            Add category
        </router-link>

        <data-table :data-set="categories" :columns="[
            {name: 'Name', type: 'text', prop: 'name'},
            {name: 'Updated', type: 'date', prop: 'updated_at', filter: ['moment', ['from', 'now']]},
            {name: 'Created', type: 'date', prop: 'created_at', filter: ['moment', ['from', 'now']]},
        ]">
            <template slot="column_Name" slot-scope="props">
                <router-link :to="{name: 'category', params:{id:props.row.id}}">
                    {{ props.row.name }}
                </router-link>
            </template>
            <template slot="controls" slot-scope="props">
                <td>
                    <div class="has-text-right">
                        <a class="delete" @click="deleteCategory(props.row)"></a>
                    </div>
                </td>
            </template>
        </data-table>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {DELETE_CATEGORY} from "../../../store/mutation-types";
    export default {
        name: 'category-list',
        data () {
            return {}
        },
        computed: mapGetters(['categories']),
        methods: {
            deleteCategory(category) {
                this.$store.dispatch(DELETE_CATEGORY, category)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// CategoryList.vue?13c1f650